import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, Facebook } from "lucide-react";
import { IMG, PHONE_DISPLAY, PHONE_TEL, EMAIL, SOCIAL } from "../../lib/site";

const Footer = () => (
  <footer className="bg-black border-t border-zinc-900 py-16 text-left">
    <div className="max-w-7xl mx-auto px-5 lg:px-12 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="space-y-4 md:col-span-1">
        <div className="flex items-center space-x-3">
          <img src={IMG.logo} alt="PRYME EPOXY logo" className="h-10 w-auto object-contain" />
          <span className="font-heading text-lg font-bold text-white tracking-widest">PRYME EPOXY</span>
        </div>
        <p className="text-zinc-400 text-sm leading-relaxed">
          Northern Arizona's trusted premium floor coating specialists. Built on craftsmanship, honesty and
          relationships. Never cutting corners.
        </p>
        <p className="text-zinc-500 text-xs uppercase tracking-widest">Licensed • Bonded • Insured</p>
        <div className="flex items-center gap-3 pt-1">
          <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="PRYME EPOXY on Instagram" data-testid="footer-instagram" className="text-zinc-400 hover:text-[#C69453] transition-colors">
            <Instagram className="w-5 h-5" />
          </a>
          <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="PRYME EPOXY on Facebook" data-testid="footer-facebook" className="text-zinc-400 hover:text-[#C69453] transition-colors">
            <Facebook className="w-5 h-5" />
          </a>
        </div>
      </div>

      <div>
        <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-4">Quick Links</h4>
        <ul className="space-y-2 text-zinc-400 text-sm">
          <li><Link to="/services" className="hover:text-[#C69453]">Services</Link></li>
          <li><Link to="/commercial" className="hover:text-[#C69453]">Commercial</Link></li>
          <li><Link to="/gallery" className="hover:text-[#C69453]">Gallery</Link></li>
          <li><Link to="/process" className="hover:text-[#C69453]">Our Process</Link></li>
          <li><Link to="/reviews" className="hover:text-[#C69453]">Reviews</Link></li>
          <li><Link to="/about" className="hover:text-[#C69453]">About Tyler</Link></li>
          <li><Link to="/faq" className="hover:text-[#C69453]">FAQ</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-4">Service Areas</h4>
        <ul className="space-y-2 text-zinc-400 text-sm">
          <li className="flex items-center space-x-2"><MapPin className="w-4 h-4 text-[#C69453]" /><Link to="/service-areas/prescott" className="hover:text-[#C69453]">Prescott, AZ</Link></li>
          <li className="flex items-center space-x-2"><MapPin className="w-4 h-4 text-[#C69453]" /><Link to="/service-areas/sedona" className="hover:text-[#C69453]">Sedona, AZ</Link></li>
          <li className="flex items-center space-x-2"><MapPin className="w-4 h-4 text-[#C69453]" /><Link to="/service-areas/flagstaff" className="hover:text-[#C69453]">Flagstaff, AZ</Link></li>
          <li><Link to="/service-areas" className="text-zinc-500 text-xs pt-1 hover:text-[#C69453]">View all areas →</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-4">Call PRYME Directly</h4>
        <a href={PHONE_TEL} className="text-[#C69453] font-bold text-2xl hover:underline flex items-center space-x-2">
          <Phone className="w-5 h-5" />
          <span>{PHONE_DISPLAY}</span>
        </a>
        <a href={`mailto:${EMAIL}`} className="text-zinc-400 text-sm hover:text-white mt-3 flex items-center space-x-2">
          <Mail className="w-4 h-4" />
          <span>{EMAIL}</span>
        </a>
        <span className="text-zinc-600 text-xs mt-4 block">
          © {new Date().getFullYear()} PRYME EPOXY. All rights reserved.
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
